import { Form }                                 from 'rewire-ui';
import { FilterComparative, UdfType }           from '../DataTypes';
import CustomFilterModel, { IPropertyMapField } from '../utility/CustomFilterModel';
import { isFilterSpecialValue }                 from './ScheduleRuleDialogModel';

export default class ScheduleRuleCustomFilterModel extends CustomFilterModel {
  constructor(propertyMapFields?: IPropertyMapField[], form?: Form) {
    super(propertyMapFields, form);
  }

  protected async mapFieldFilterValueToFormFieldValue(value?: any, type?: UdfType, comparative?: FilterComparative): Promise<any> {
    return isFilterSpecialValue(value) ? value : super.mapFieldFilterValueToFormFieldValue(value, type, comparative);
  }

  protected mapFormFieldValueToFieldFilterValue(value?: any, type?: UdfType, comparative?: FilterComparative): any {
    return isFilterSpecialValue(value) ? value : super.mapFormFieldValueToFieldFilterValue(value, type, comparative);
  }
} 